import i18n from '@/language/i18n';

const WORK_CALENDAR_TYPES = Object.freeze({
    MONTH: { value: 'month', text: i18n.t('Common.month') },
    WEEK: { value: 'week', text: i18n.t('Common.week') },
    DAY: { value: 'day', text: i18n.t('Common.day') },
});

export default WORK_CALENDAR_TYPES;
